'use client';
import React, { useCallback, useMemo, useState } from 'react';
import LoaderContext, { LoaderContextProps } from '@src/v3/contexts/loader';

interface LoaderProviderProps {
  children: React.ReactNode;
}

const LoaderProvider: React.FC<LoaderProviderProps> = ({ children }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [loaderType, setLoaderType] = useState('');

  // Stable identities: consumers put these in `useCallback`/`useEffect` dependency
  // arrays, so a new function per render would refire their effects on every
  // loader flip. Only state setters are called, and those are already stable.
  const showLoader = useCallback((type = ''): void => {
    setIsLoading(true);
    setLoaderType(type);
  }, []);

  const hideLoader = useCallback((): void => {
    setIsLoading(false);
    setLoaderType('');
  }, []);

  const loaderContextValue: LoaderContextProps = useMemo(
    () => ({
      isLoading,
      loaderType,
      showLoader,
      hideLoader,
    }),
    [isLoading, loaderType, showLoader, hideLoader]
  );

  return (
    <LoaderContext.Provider value={loaderContextValue}>
      {children}
    </LoaderContext.Provider>
  );
};

export default LoaderProvider;
